import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { toast } from "react-toastify";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import {
  bulk_approval_view_all_api,
  getdistictName,
  submitLimits,
  bulk_approval_show_api,
  modifydetails,
  RejectRequirement,
  bulk_approval_api_weo,
  approvalApiDwo,
} from "../api/Users";
import { Modal } from "react-bootstrap";
import { Typography } from "@mui/material";
import { TextField, TablePagination, Button, Checkbox } from "@mui/material";

const AllocatedAmenitiesLimits = ({ role, props, userData }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [Alldistricts, setAllDistricts] = useState([]);
  const [financialYear, setFinancialYear] = useState("");
  const [District, setDistrict] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [fundType, setFundType] = useState("");
  const [rowData, setRowData] = useState([
    {
      programLimit: "",
      repairLimit: "",
      assetLimit: "",
    },
  ]);
  const [ViewAll, setViewAll] = useState(false);
  const [postSchoolName, setPostSchoolname] = useState([]);
  const [viewFilteredData, setViewFilteredData] = useState([]);
  const [requirementDistrictName, setRequirementDistrictName] = useState("");
  const [MainSelectedRow, setMainSelectedRow] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(31);
  const [page, setPage] = useState(0);
  const [additionalDistrictCode, setAdditionalDistrictCode] = useState("");
  const [datasByRow, setDatasByRow] = useState([]);
  const [datas, setDatas] = useState(datasByRow);

  useEffect(() => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          setAllDistricts(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching districts:", err);
      });
  }, []);

  const handleFinancialChange = (e) => {
    setFinancialYear(e.target.value);
    setDistrict("");
    setFundType("");
    setIsLoading(false);
    setShowTable(false);
  };

  const handleDistrictChange = async (e) => {
    const districtCode = e.target.value;
    if (districtCode !== "all") {
      const selectedDistrict = Alldistricts.find(
        (district) => district.district_code === districtCode
      );
      if (selectedDistrict) {
        setDistrict(selectedDistrict.district_code);
        setRowData([
          {
            district_code: selectedDistrict.district_code,
            assetLimit: 0,
            repairLimit: 0,
            programLimit: 0,
          },
        ]);
      } else {
        console.error("Selected district not found");
      }
    } else {
      setDistrict("all");
      const districtsData = Alldistricts.map((district) => ({
        district_code: district.district_code,
        assetLimit: 0,
        repairLimit: 0,
        programLimit: 0,
      }));
      setFilteredData(districtsData);
    }
  };

  const handleFundType = async (e) => {
    setFundType(e.target.value);
    setShowTable(true);
    if (e.target.value == 2) {
      setFilteredData([]);
      setIsLoading(true);
      const data = {
        role_id: role,
        district_code: District ? District : "all",
      };

      bulk_approval_show_api(data).then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data);

          res.data.length > 0
            ? setAdditionalDistrictCode(res.data[0].district_code)
            : setAdditionalDistrictCode("");
        } else {
          setFilteredData([]);
          toast.error(t("No Data Available!"));
        }
      });
      setIsLoading(false);
    } else {
      if (District !== "all") {
        const selectedDistrict = Alldistricts.find(
          (district) => district.district_code === District
        );
        if (selectedDistrict) {
          setDistrict(selectedDistrict.district_code);
          setRowData([
            {
              district_code: selectedDistrict.district_code,
              assetLimit: 0,
              repairLimit: 0,
              programLimit: 0,
            },
          ]);
        } else {
          console.error("Selected district not found");
        }
      } else {
        const districtsData = Alldistricts.map((district) => ({
          district_code: district.district_code,
          assetLimit: 0,
          repairLimit: 0,
          programLimit: 0,
        }));
        setFilteredData(districtsData);
      }
    }
  };

  const handleInputChange = (value, row, name) => {
    setFilteredData((prevData) =>
      prevData.map((d) =>
        d.district_code === row.district_code
          ? { ...d, [name]: parseInt(value, 10) }
          : d
      )
    );
  };

  const handleSubmitForm = async (event) => {
    event.preventDefault();

    const filteredRowData = filteredData.filter((row) => row.assetLimit > 0);
    if (filteredRowData.length === 0) {
      toast.error("No limits set for any district.");
      return;
    }
    const submitPostData = {
      academic_year: financialYear,
      fund_master_id: fundType,
      fund_allocation: filteredRowData.map((row) => {
        const { district_code, assetLimit, repairLimit, programLimit } = row;
        const allocationData = {
          district_code:
            fundType !== "2" ? district_code : additionalDistrictCode,
          assetLimit,
        };
        if (fundType !== "2") {
          allocationData.repairLimit = repairLimit;
          allocationData.programLimit = programLimit;
        }
        return allocationData;
      }),
    };

    submitLimits(submitPostData)
      .then((response) => {
        toast.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        console.error("Error submitting limits:", error);
        toast.error("Failed to submit limits.");
      });
  };

  const handleCloseViewModal = () => {
    setViewAll(false);
  };

  const handleViewClick = (row) => {
    let data;
    if (role === 6) {
      data = {
        role_id: role,
        amenities_id: row.amenities_id,
        amenities_sub_type_id: row.amenities_sub_type_id,
      };
    } else if (role === 8 || role === 11) {
      data = {
        role_id: role,
        district_code: row.district_code,
      };
    } else {
      data = {
        role_id: role,
        school_id: row.school_id,
      };
    }

    bulk_approval_view_all_api(data).then((res) => {
      if (res.status === "success") {
        setViewFilteredData(res.data);
        setPostSchoolname(row.school_name);
        setRequirementDistrictName(res.data[0].district);
      } else {
        toast.error(t("No Data Available!"));
      }
    });
    setMainSelectedRow(true);
    setViewAll(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <h5 className="my-4">{t("District Fund Allocation")}</h5>
        <form id="myform" style={{ marginTop: "12px" }}>
          <div className="row">
            <div className="col-md-3">
              <label className="form-label">
                {t("Financial Year")} <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="finencial_year"
                className="common-input form-select"
                onChange={handleFinancialChange}
                required
              >
                <option value="">{t("Select Financial Year")}</option>
                <option value="2024-25">2024-25</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">
                {t("District")} <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="district"
                className="common-input form-select"
                onChange={handleDistrictChange}
                value={District}
                required
              >
                <option value="">{t("Select District")}</option>
                <option value="all">{t("All")}</option>
                {Alldistricts.map((row, index) => (
                  <option key={index} value={row.district_code}>
                    {row.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">
                {t("Fund Type")} <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="asset_type_id"
                className="common-input form-select"
                onChange={handleFundType}
                value={fundType}
                required
              >
                <option value="">{t("Select Fund Type")}</option>
                <option value="1">{t("Generic")}</option>
                <option value="2">{t("Additional")}</option>
              </select>
            </div>
          </div>
          {showTable && (
            <div
              className="row col-12 d-flex justify-content-center"
              style={{ marginTop: "12px" }}
            >
              <div className="col-md-10 justify-content-center">
                <TableContainer
                  component={Paper}
                  style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                  className="my-4"
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {District === "all" && (
                          <TableCell style={{ width: 100 }} align="center">
                            {t("Sr No.")}
                          </TableCell>
                        )}
                        <TableCell align="center" style={{ width: 100 }}>
                          {t("District Name")}
                        </TableCell>
                        <TableCell align="center" style={{ width: 100 }}>
                          {t("Assets")}
                        </TableCell>
                        {fundType !== "2" && (
                          <>
                            <TableCell align="center" style={{ width: 100 }}>
                              {t("Repair & Maintenance")}
                            </TableCell>
                            <TableCell style={{ width: 100 }} align="center">
                              {t("Program")}
                            </TableCell>
                          </>
                        )}
                        {fundType === "2" && (
                          <TableCell style={{ width: 100 }} align="center">
                            {t("Action")}
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>

                    {!isLoading &&
                      role > 7 &&
                      filteredData &&
                      filteredData.length > 0 && (
                        <TableBody style={{ color: "white" }}>
                          {filteredData
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => (
                              <TableRow key={index}>
                                <TableCell
                                  style={{ width: 100 }}
                                  align="center"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  style={{ width: 100 }}
                                  align="center"
                                >
                                  {Alldistricts.find(
                                    (d) => d.district_code === row.district_code
                                  )?.name || ""}
                                </TableCell>
                                <TableCell
                                  style={{ width: 100 }}
                                  align="center"
                                >
                                  <input
                                    type="number"
                                    name="assetLimit"
                                    className="form-control"
                                    value={rowData.assetLimit}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e.target.value,
                                        row,
                                        "assetLimit"
                                      )
                                    }
                                  />
                                </TableCell>
                                {fundType !== "2" && (
                                  <>
                                    <TableCell
                                      style={{ width: 100 }}
                                      align="center"
                                    >
                                      <input
                                        type="number"
                                        name="repairLimit"
                                        className="form-control"
                                        value={rowData.repairLimit}
                                        onChange={(e) =>
                                          handleInputChange(
                                            e.target.value,
                                            row,
                                            "repairLimit"
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      className="d-flex justify-content-center"
                                    >
                                      <input
                                        type="number"
                                        name="programLimit"
                                        className="form-control"
                                        value={rowData.programLimit}
                                        onChange={(e) =>
                                          handleInputChange(
                                            e.target.value,
                                            row,
                                            "programLimit"
                                          )
                                        }
                                      />
                                    </TableCell>
                                  </>
                                )}
                                {fundType === "2" && (
                                  <TableCell
                                    style={{ width: 100 }}
                                    align="center"
                                  >
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={() => handleViewClick(row)}
                                    >
                                      {t("View All")}
                                    </button>
                                  </TableCell>
                                )}
                              </TableRow>
                            ))}
                        </TableBody>
                      )}
                  </Table>

                  <div className="col-md-11 d-flex justify-content-end my-4 mx-4">
                    <button
                      type="button"
                      onClick={(e) => handleSubmitForm(e)}
                      className="btn btn-primary me-2"
                    >
                      {t("Submit")}
                    </button>
                  </div>
                </TableContainer>
              </div>
            </div>
          )}
        </form>
      </div>
      {MainSelectedRow && (
        <Modal
          show={ViewAll}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "32%",
              left: "52%",
              transform: "translate(-50%, 8%)",
              minWidth: "91vw",
              maxWidth: "95vw",
              maxHeight: "90vh",
              width: "100%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t(`All Requirement for ${requirementDistrictName}`)}
            </Typography>
            <div className="Table mb-6">
              <TableContainer
                component={Paper}
                style={{
                  boxShadow: "0px 13px 20px 0px #80808029",
                  overflow: "scroll",
                  maxHeight: "50vh",
                  overflowX: "hidden",
                }}
                className="my-4"
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">{t("Sr. No.")}</TableCell>
                      <TableCell align="center">{t("Requirement")}</TableCell>
                      <TableCell align="center">{t("School Name")}</TableCell>
                      <TableCell align="center">{t("GBC")}</TableCell>
                      <TableCell align="center">{t("Hostel Type")}</TableCell>
                      <TableCell align="center">{t("District")}</TableCell>
                      <TableCell align="center">{t("Block")}</TableCell>
                      <TableCell align="center">{t("Quantity")}</TableCell>
                      <TableCell align="center">{t("Raised On")}</TableCell>
                      <TableCell align="center">
                        {t("Pending Date Count")}
                      </TableCell>
                      {role == 6 ? (
                        <TableCell align="center">
                          {t("Is Fund Available")}
                        </TableCell>
                      ) : (
                        ""
                      )}
                      <TableCell
                        align="center"
                        style={{
                          display:
                            role == 7 || role == 12 || role == 13
                              ? "none"
                              : "block",
                        }}
                      >
                        {t("Reason")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ color: "white" }}>
                    {viewFilteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {getSerialNumber(index)}
                          </TableCell>
                          <TableCell align="center">
                            {row.requirement_name}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.school_name}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.gbc_type}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.hostel_type}
                          </TableCell>
                          <TableCell align="center">{row.district}</TableCell>
                          <TableCell align="center">{row.block}</TableCell>
                          <TableCell align="center">{row.quantity}</TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.creation_date}
                          </TableCell>
                          <TableCell align="center">
                            {row.pending_date_count}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography>
                              <input
                                style={{ width: "10rem" }}
                                type="textbox"
                                name="reason"
                                value={row.reason}
                                className={`form-control`}
                                disabled
                              />
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <button
                  variant="contained"
                  color="primary"
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "none",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                  }}
                  onClick={handleCloseViewModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={viewFilteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
            <div
              className=""
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-secondary"
                style={{
                  marginRight: "66px",
                  display:
                    role == 7 || role == 12 || role == 13 ? "none" : "block",
                }}
                onClick={handleCloseViewModal}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AllocatedAmenitiesLimits;
